import React from 'react';

const DonationProcessing = () => {
  return (
    <div className="l-section__content-wrapper mt-12 pt-0 px-md-20">
      <div className="d-flex flex-column justify-content-center align-items-center py-6">
        <span className="c-spinner"/>
        <span className="mt-5 fs-4">
          Processing payment
        </span>
      </div>
    </div>
  );
};

export default DonationProcessing;